import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { motion } from 'framer-motion'

import { isIphone } from '@/utils/device'
import { PiCalendar, PiUser, PiCaretDownFill, PiDownloadSimple, PiFileXls } from 'react-icons/pi'

import QuickActionsModal from '../QuickActionsModal/QuickActionsModal';
import { useDashboardStore } from '@/store/useDashboardStore';

import { API_URL } from '@/services/api/config';
import { useUserStore } from '@/store/useUserStore';

const Header = () => {
  const { t } = useTranslation()
  const user = useUserStore((state) => state.user)
  const financialYear = useDashboardStore((state) => state.financialYear)

  const navigate = useNavigate()
  const [actionsOpen, setActionsOpen] = useState(false)

  const journalActions = [
    {
      icon: <PiFileXls className="w-10 h-10 text-white" />,
      text: t('dashboard.journal.downloadExcel'),
      subtext: "",
      onClick: () => setActionsOpen(false),
      to: `${API_URL}/user/cashflow?year=${financialYear}&sgid=${user?.sgid.cashflow}`,
      className: "rounded-3xl"
    },
  ];

  return (
    <>
      <div className={`tour-header flex items-center px-4 pb-3 ${isIphone ? 'pt-1' : 'pt-3'}`}>
        <motion.button className="p-2 text-zinc-700 bg-zinc-100 rounded-full mr-4"
          whileTap={{ scale: 0.98 }}
          onClick={() => navigate('/profile')}
        >
          <PiUser className="w-5 h-5" />
        </motion.button>
        <motion.button className="mr-auto flex flex-row py-1 pr-3 pl-[0.625rem] h-9 items-center gap-[0.375rem] font-semibold py-2 text-sm rounded-full bg-zinc-100 text-zinc-900"
          whileTap={{ scale: 0.98 }}
          onClick={() => navigate('/year')}
        >
          <PiCalendar className="w-5 h-5" />
          <span>{financialYear}</span>
          <PiCaretDownFill className="w-3 h-3" />
        </motion.button>
        <motion.button className="flex flex-row py-1 pr-3 pl-[0.625rem] h-9 items-center gap-[0.375rem] font-semibold py-2 text-sm rounded-full bg-zinc-100 text-zinc-900 cursor-pointer"
          whileTap={{ scale: 0.98 }}
          onClick={() => setActionsOpen(true)}
        >
          <PiDownloadSimple className="w-4 h-4" />
          {t('dashboard.journal.ivJournal')}
        </motion.button>
      </div>
      <QuickActionsModal
        actions={journalActions}
        isOpen={actionsOpen}
        setOpen={setActionsOpen}
      />
    </>
  )
}

export default Header